import { render, staticRenderFns } from "./board-card.vue?vue&type=template&id=9bfa2272&scoped=true"
import script from "./board-card.vue?vue&type=script&lang=js"
export * from "./board-card.vue?vue&type=script&lang=js"
import style0 from "./board-card.vue?vue&type=style&index=0&id=9bfa2272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfa2272",
  null
  
)

export default component.exports